function shouldDisableButton(formik) {
  // console.log(formik.errors)
  return !(Object.keys(formik.errors).length === 0)
}

export default shouldDisableButton
